import roles from './roles'

const { all, agents, heads, admin, stateHead, agencyHead, stateStaff } = roles

export default [
  // dashboard permissions
  { id: 'view_dashboard', roles: [...all] },

  // aid permissions
  { id: 'view_aid', roles: [...all] },
  { id: 'view_aids', roles: [...all] },
  { id: 'create_aid', roles: [...agents] },

  // event permissions
  { id: 'view_event', roles: [...all] },
  { id: 'view_events', roles: [...all] },
  { id: 'create_event', roles: [...agents] },
  { id: 'edit_event', roles: [...agents] },
  
  // state permissions
  { id: 'view_states', roles: [admin] },
  { id: 'create_state', roles: [] },
  { id: 'edit_state', roles: [admin] },

  // agency permissions
  { id: 'view_agencies', roles: [admin, stateHead] },
  { id: 'create_agency', roles: [admin, stateHead] },

  // location permissions
  { id: 'view_locations', roles: [admin, ...heads, stateStaff] },
  { id: 'create_location', roles: [admin, ...heads] },
  { id: 'edit_location', roles: [admin, ...heads] },

  // beneficiary permissions
  { id: 'view_beneficiaries', roles: [admin] },
  { id: 'create_beneficiary', roles: [admin] },

  // sector permissions
  { id: 'view_sectors', roles: [admin] },
  { id: 'create_sector', roles: [admin] },

  // category permissions
  { id: 'view_categories', roles: [admin] },
  { id: 'create_category', roles: [admin] },

  // analytics permissions
  { id: 'view_analytics', roles: [admin] },

  // user permissions
  { id: 'view_users', roles: [admin, ...heads] },
  { id: 'view_admins', roles: [admin] },
  { id: 'view_agents', roles: [admin, ...heads] },
  { id: 'view_state_agents', roles: [admin, stateHead] },
  { id: 'view_agency_agents', roles: [admin, agencyHead] },
  { id: 'create_user', roles: [admin, ...heads] },
  { id: 'create_admin', roles: [admin] },
  { id: 'create_state_head', roles: [admin, stateHead] },
  { id: 'create_agency_head', roles: [admin, agencyHead] },
  { id: 'create_state_staff', roles: [stateHead] },
  { id: 'create_agency_staff', roles: [agencyHead] },
  { id: 'assign_state_head', roles: [stateHead] },
  { id: 'assign_state_staff', roles: [stateHead] },
  { id: 'assign_agency_head', roles: [agencyHead] },
  { id: 'assign_agency_staff', roles: [agencyHead] }
]
